import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { searchUserServiceId } from "../../services/User/UsersServices";
import "../General.css";
import "./AdminLayout.css";

/**
 * sessionStorage.superUser is set at login time from a real UserData lookup
 * (see SignIn.tsx), but it's still just a client-side flag that could go
 * stale or be tampered with after the fact. Re-verifying userType===3 against
 * the backend here (same call Navbar.tsx already makes) is what actually
 * gates access — every mutation an admin page performs is independently
 * enforced server-side via @PreAuthorize anyway.
 */
const AdminLayout = () => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      navigate("/");
      return;
    }
    searchUserServiceId({ _id: userId })
      .then((res: any) => {
        if (res?.data?.userType === 3) {
          setChecked(true);
        } else {
          sessionStorage.removeItem("superUser");
          navigate("/");
        }
      })
      .catch(() => {
        sessionStorage.removeItem("superUser");
        navigate("/");
      });
  }, [navigate]);

  if (!checked) {
    return null;
  }

  return (
    <div className="admin-shell">
      <nav className="admin-sidebar">
        <div className="admin-sidebar-brand">BIZalp Admin</div>

        <NavLink to="/admin" end className="admin-sidebar-link">
          {t("common:adminDashboard")}
        </NavLink>

        <div className="admin-sidebar-group">
          <NavLink to="/admin/users" className="admin-sidebar-link">
            {t("common:userList")}
          </NavLink>
          <NavLink to="/admin/companies" className="admin-sidebar-link">
            {t("common:companies")}
          </NavLink>
          <NavLink to="/admin/companyRecovery" className="admin-sidebar-link">
            {t("common:companyRecovery")}
          </NavLink>
        </div>

        <div className="admin-sidebar-group">
          <div className="admin-sidebar-group-label">{t("common:catalog")}</div>
          <NavLink to="/admin/categories" className="admin-sidebar-link">
            {t("common:productCat")}
          </NavLink>
          <NavLink to="/admin/product-types" className="admin-sidebar-link">
            {t("common:prodType")}
          </NavLink>
          <NavLink to="/admin/products" className="admin-sidebar-link">
            {t("common:products")}
          </NavLink>
          <NavLink to="/admin/product-images" className="admin-sidebar-link">
            {t("common:productPhoto")}
          </NavLink>
        </div>

        <div className="admin-sidebar-group">
          <NavLink to="/admin/suppliers" className="admin-sidebar-link">
            {t("common:suppliers")}
          </NavLink>
          <NavLink to="/admin/orders" className="admin-sidebar-link">
            {t("common:orders")}
          </NavLink>
        </div>

        <div className="admin-sidebar-group">
          <div className="admin-sidebar-group-label">{t("common:community")}</div>
          <NavLink to="/admin/posts" className="admin-sidebar-link">
            {t("common:posts")}
          </NavLink>
          <NavLink to="/admin/comments" className="admin-sidebar-link">
            {t("common:comments")}
          </NavLink>
          <NavLink to="/admin/notifications" className="admin-sidebar-link">
            {t("common:notifications")}
          </NavLink>
        </div>
      </nav>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
